module.exports = __webpack_public_path__ + "static/media/libby4.c8332e34.png";